import React from 'react';
import {AdminCreateObrComponent} from '../../component/adminCreateObr/AdminCreateObrComponent';
export const AdminManageExpertUserPage = () => {
    return (
        <>
            <AdminCreateObrComponent />
        </>
    )
}